<template>
    <div
      v-if="isLoading"
      :class="['loading-overlay', isFullScreen ? 'fullScreen' : '']"
      :style="`background-color: ${backgroundColor}`">
      <div class="loading-content">
        <img src="@/assets/images/icon/loading.svg" alt="Loading" class="loading-image" />
        <p v-if="text" class="loading-text">{{ loadingText }}</p>
      </div>
    </div>
  </template>

<script>
export default {
  name: 'Loading',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    fullScreen: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loadingStatus: false,
      fullScreenStatus: false,
      content: '',
      backgroundColor: '',
    };
  },
  computed: {
    isLoading() {
      return this.loading || this.loadingStatus;
    },
    isFullScreen() {
      return this.fullScreen || this.fullScreenStatus;
    },
    loadingText() {
      return this.text || this.content;
    },
  },

  methods: {
    close() {
      this.loadingStatus = false;
      this.$destroy(true);
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
    },
  },
};
</script>

<style lang="less" scoped>
.loading-overlay {

  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 300;
  &.fullScreen {
    position: fixed;
    top: 0;
    left: 0;
  }
}

.loading-content {
  text-align: center;
}

.loading-image {
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

.loading-text {
  margin-top: 10px;
  color: white;
  font-size: 16px;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
